import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { Experiment } from 'modules/graphql/types';
import { BasePageExperimentVariant } from './analyticsBasePage';

/**
 * Picking just the needed attributes of the main Experiment type.
 * And, forming a new type based on the EXPERIMENT_ATTRIBUTES
 * src/api/fragments/experiments.ts
 * */
type PickExperimentProperties = Pick<
  Experiment,
  | 'id'
  | 'name'
  | 'type'
  | 'createdAt'
  | 'createdBy'
  | 'modifiedAt'
  | 'startedAt'
  | 'endedAt'
  | 'exploitationStartedAt'
  | 'state'
  | 'evenlySplitVariations'
  | 'winningCriteria'
>;

type PickExperimentCampaignDefinitionProperties = {
  campaign: Pick<
    Experiment['campaign'],
    'id' | 'name' | 'type' | 'state' | 'messageMedium' | 'sendTimeUseRecipientTimeZones' | 'labels'
  >;
};

export type ExperimentTableData = PickExperimentProperties &
  PickExperimentCampaignDefinitionProperties &
  BasePageExperimentVariant;

export type ExperimentsTableItem = ExperimentTableData & {
  conversionWinner?: string;
};

export type ExperimentsTableInfo = {
  count: number;
  limit: number;
  offset: number;
  page: number;
};

export type ExperimentsTableContent = ExperimentsTableRow[];

export type ExperimentsTableRow = ExperimentsTableItem; // | ExperimentsTableFolder;

export type ExperimentsTableData = {
  info?: ExperimentsTableInfo;
  results?: ExperimentsTableContent;
};

export type ExperimentsMock = {
  experiments: ExperimentsTableData;
};

export type ExperimentsTableDataState = {
  items: ExperimentsTableData;
  loading: boolean;
  error: boolean;
};

export enum EXPERIMENTS_TABLE_COLUMNS {
  NAME = 'Name',
  SUBJECT = 'TestSubject',
  CONVERSION_WINNER = 'conversionWinner',
  STATUS = 'ExperimentState',
  START_DATE = 'StartedAt',
  END_DATE = 'EndedAt',
  LAST_MODIFIED = 'LastModified',
}

export type EXPERIMENTS_TABLE_COLUMN = {
  id: EXPERIMENTS_TABLE_COLUMNS;
  label: string;
  isSortable: boolean;
  initialSortDirection: SORT_DIRECTIONS;
  isRightAligned: boolean;
};
